import PluralizationRule from "./PluralizationRule";

export default class PluralizedParameter {
    public readonly identifier: string;
    private readonly pluralizationRules: Array<PluralizationRule>;

    constructor(parameterIdentifier: string, pluralizationRules: Array<PluralizationRule>) {
        this.identifier = parameterIdentifier;
        this.pluralizationRules = pluralizationRules;
    }

    public getPluralizedText(parameter: number): string {
        var foundRules = this.pluralizationRules.filter(rule =>
            rule.interval.contains(Math.abs(parameter) % 10)
        );
        return foundRules[0].text;
    }
}
